import { useMediaQuery, useTheme } from '@mui/material';

import { BannerAlertMessagesCollection, BannerMobileAlertMessagesCollection, ContentTypeRichText } from '@/graphql/__generated/sdk';

import AlertBanner from './AlertBanner/AlertBanner';

export interface IBanner {
    variant: 'Alert Banner' | null // Type of the banner;
    alertMessagesCollection?: BannerAlertMessagesCollection;
    mobileAlertMessagesCollection?: BannerMobileAlertMessagesCollection;
    dataTestId?: string;
}

export default function Banner({
    variant = 'Alert Banner', 
    alertMessagesCollection,
    mobileAlertMessagesCollection,
    dataTestId
} : Readonly<IBanner>) {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const alertMessages = isSmallScreen ? mobileAlertMessagesCollection?.items : alertMessagesCollection?.items;

       
    return variant === 'Alert Banner' && alertMessages ? (
        <AlertBanner
            dataTestId={dataTestId}
            alertMessages={alertMessages as ContentTypeRichText[]}
        />
    ) : null;
    
}